import { render, staticRenderFns } from "./contador-caracteres.vue?vue&type=template&id=2ab451a4&"
import script from "./contador-caracteres.vue?vue&type=script&lang=ts&"
export * from "./contador-caracteres.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports